import { Component, OnInit } from '@angular/core';
import { LoginService } from '../service/login.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from "@angular/router";
import { PerfilService } from '../service/perfil.service';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormGroup } from '@angular/forms';
import { AuthService } from '../service/auth.service';
import { SettingService } from '../service/setting.service';
import { TurnstileService } from '../service/turnstile.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  session: any
  default = true;
  recuperar = false;
  nuevo = false;
  mensaje = false;
  title = "Bienvenido";
  subTitle = "Inicia sesión para continuar";
  button = "Iniciar sesión";
  json: any;
  dpi: any = "";
  nombre: string;
  apePaterno: string;
  apeMaterno: string;
  apeCasada: string;
  sexo = 'M';
  fecNacimiento: string;
  nacionalidad: string;
  direccion: string;
  email: string;
  REemail: string;
  tel: string;
  passReset = false;
  // fechaAux = new Date();
  fechaAux = '';

  validaCorreo: boolean = false;
  mensajeValidacion: boolean = false;

  aceptaPoliticaTarjeta: boolean = false;
  mostrarPoliticaTarjeta: boolean = false;

  password: string;
  password2: string
  tipo: number;
  response: any;
  errorMensaje: any;
  hostname: string
  ip: any;
  token: any;
  tokenValida: any;
  bloqueo = 0;
  version = '1.15.0'
  loading = false;

  ruta = this.settingsService.settings.ipFyService;

  formLogin = new FormGroup({
    dpi: new FormControl(),
    pass: new FormControl()
  })

  constructor(private login: LoginService, private route: Router, private perfil: PerfilService,
    private http: HttpClient, private rout: ActivatedRoute, private auth: AuthService, private settingsService: SettingService,
    private turnstile: TurnstileService ) {
    // this.auth.logout(true)
    this.login.currentSession.subscribe(login => this.session = login);
    this.rout.queryParams.subscribe(params => {
      this.token = params['token'];
      this.tokenValida = params['tokenValidacion'];
      if (this.token) {
        this.change(5);
      }

      if (this.tokenValida) {
        this.change(6);
      }
    });
  }

  ngOnInit() {
    this.tipo = 1;
    this.ip = { ip: '127.0.0.1' }
    this.dpi = "",
    this.nombre = "",
    this.apePaterno = "",
    this.apeMaterno = "",
    this.apeCasada = "",
    this.password = "",
    this.sexo = "",
    this.email = "",
    this.fecNacimiento = "",
    this.nacionalidad = "",
    this.direccion = "",
    this.tel = ""

    this.fechaAux = this.formatYMD(new Date());

  }

  formatYMD(d: Date): string {
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
  }

  toDdMmYyyy(val: string): string  {
    const [y, m, d] = val.split('-');
    return `${d}-${m}-${y}`;
  }

  async send(tipo: number) {
  this.errorMensaje = "";
  this.loading = true;

  // Genera el token de Cloudflare Turnstile antes de armar el request.
  // La verificación real se hace en el backend contra la API de Cloudflare con la llave secreta.
  let captchaToken = '';
  const turnstileAction: { [key: number]: string } = {
    1: 'login',
    2: 'signup',
    3: 'recover_password',
    4: 'validate_email'
  };
  if (turnstileAction[tipo]) {
    try {
      captchaToken = await this.turnstile.execute(turnstileAction[tipo]);
    } catch (e) {
      console.error('turnstile error', e);
      // seguimos sin token: el backend decide qué hacer si falta
    }
  }

  switch (tipo) {
    case 1: {
      this.json = {
        sDni: this.dpi,
        sPassword: this.password,
        sHost: this.ip.ip || '127.0.0.1',
        nIdEmpresa: 5,
        sCaptchaToken: captchaToken
      };

      if (!this.dpi || this.dpi.trim() === "") {
        this.errorMensaje = "Ingrese los datos solicitados";
        this.loading = false;
        return;
      }
      if (!this.password || this.password.trim() === "") {
        this.errorMensaje = "Ingrese los datos solicitados";
        this.loading = false;
        return;
      }

      const localDevUrl = 'http://localhost:4200/Pocae';
      const appUrl = (window.location.hostname === 'localhost') ? localDevUrl : this.ruta + '/Pocae-Panama';

      const validaJson = {
        sDni: this.dpi,
        sAppUrl: appUrl,
        nIdEmpresa: 5,
        sCaptchaToken: captchaToken
      };

      // Primero validamos correo
      this.login.validaCorreo(validaJson).subscribe({
        next: async (resVal) => {
          this.response = resVal;
          if (this.response?.estado?.numeroError !== 0) {
            this.loading = false;
            this.errorMensaje = this.response.estado.mensajeError;
            return;
          }

          // Token nuevo para este segundo request: los tokens de Turnstile
          // son de un solo uso, el de "verificar" ya se consumió arriba.
          try {
            this.json.sCaptchaToken = await this.turnstile.execute('login');
          } catch (e) {
            console.error('turnstile error', e);
          }

          // Ahora iniciamos sesión
          this.login.iniciar(this.json).subscribe({
            next: (resLogin) => {
              this.response = resLogin;

              if (this.response?.estado?.numeroError !== 0) {
                this.loading = false;
                this.errorMensaje = this.response.estado.mensajeError;
                return;
              }
              localStorage.setItem('loggingOut', '1');

              this.auth.cancelPendingRequests$.next();

              const newKsi = this.response.sesion.sIdSesion;
              localStorage.setItem('KSI', newKsi);

              const body = {
                ksi: newKsi,
                name: this.response.sesion.sNombre,
                idUsuario: this.response.sesion.nIdUsuarioWeb,
                idEmpresa: this.response.sesion.nIdEmpresa,
                bloqueos: this.response.bloqueos,
                dpi: this.dpi
              };
              localStorage.setItem('sesionPocae', JSON.stringify(body));
              localStorage.setItem('name', this.response.sesion.sNombre);
              localStorage.setItem('nombre', this.response.sesion.sNombre);
              localStorage.setItem('idEmpresa', this.response.sesion.nIdEmpresa.toString());

          
              this.auth.setCurrentSession({
                sIdSesion: this.response.sesion.sIdSesion,
                idUsuario: this.response.sesion.nIdUsuarioWeb,
                idEmpresa: this.response.sesion.nIdEmpresa
              });

              localStorage.removeItem('loggingOut');

          
              this.login.addSession(
                this.response.sesion.sIdSesion,
                this.response.sesion.sNombre,
                this.ip.ip,
                this.response.sesion.nIdUsuarioWeb,
                this.response.bloqueos
              );

              
              this.perfil.addCards(this.dpi);
              this.perfil.addCurrentUser(
                this.response.sesion.nombres || this.response.sesion.sNombre || '',
                this.response.sesion.apePat || this.response.sesion.apellidoPaterno || '',
                this.response.sesion.apeMat || this.response.sesion.apellidoMaterno || ''
              );

              
              this.route.navigate(['/pocae/resumen']);
              this.loading = false;
            },
            error: (err) => {
              console.error('login.iniciar error', err);
              this.loading = false;
              
              this.errorMensaje = err?.error?.estado?.mensajeError || 'Error al iniciar sesión. Intente más tarde.';
            }
          });

        },
        error: (errVal) => {
          console.error('login.validaCorreo error', errVal);
          this.loading = false;
          this.errorMensaje = errVal?.error?.estado?.mensajeError || 'Error al validar correo. Intente más tarde.';
        }
      });

      break;
    }

    case 2: {
      this.json = {
        usuario: {
          sDni: this.dpi,
          sNombres: this.nombre,
          sApellidoPaterno: this.apePaterno,
          sApellidoMaterno: this.apeMaterno,
          sApellidoCasada: '',
          sPassword: this.password,
          sSexo: this.sexo,
          sCorreo: this.email,
          sFechaNacimiento: this.toDdMmYyyy(this.fecNacimiento),
          sNacionalidad: this.nacionalidad,
          sDireccion: this.direccion,
          sTelefono: this.tel,
          sPregunta: '',
          sRespuesta: '',
          nIdEmpresa: 5
        },
        sCaptchaToken: captchaToken
      };

      if (!this.aceptaPoliticaTarjeta) {
        this.errorMensaje = "Debes autorizar el registro y tratamiento de tus datos para continuar";
        this.loading = false;
        return;
      }
      if (!this.comproboPass()) {
        this.errorMensaje = "Las contraseñas no coinciden";
        this.loading = false;
        return;
      }
      if (!this.comproboField()) {
        this.errorMensaje = "Completa todos los campos";
        this.loading = false;
        return;
      }
      if (!this.comproboEmail()) {
        this.errorMensaje = "Mail inválido";
        this.loading = false;
        return;
      }
      if (!this.comprobReEmail()) {
        this.errorMensaje = "Ambos email deben ser iguales";
        this.loading = false;
        return;
      }
      if (this.comproboDate()) {
        this.errorMensaje = "Fecha inválida";
        this.loading = false;
        return;
      }
      if (this.password.length < 6) {
        this.errorMensaje = "Contraseña debe tener mínimo 6 caracteres";
        this.loading = false;
        return;
      }

      this.perfil.addUser(this.json).subscribe({
        next: (res) => {
          this.response = res;
          if (this.response?.estado?.numeroError !== 0) {
            this.loading = false;
            this.errorMensaje = this.response?.estado?.mensajeError;
          } else {
            this.loading = false;
            this.change(4);
          }
        },
        error: (err) => {
          console.error('perfil.addUser error', err);
          this.loading = false;
          this.errorMensaje = err?.error?.estado?.mensajeError || 'Error al crear usuario';
        }
      });

      break;
    }

    case 3: {
      this.json = {
        sCorreo: this.email,
        sAppUrl: window.location.origin + '/Pocae-Panama',
        nIdEmpresa: 5,
        sCaptchaToken: captchaToken
      };
      if (!this.comproboEmail()) {
        this.errorMensaje = "Mail inválido";
        this.loading = false;
      } else {
        this.login.recuperar(this.json).subscribe({
          next: (res) => {
            this.response = res;
            const { estado } = this.response;
            const { numeroError, mensajeError } = estado;
            if (numeroError !== 0) {
              this.loading = false;
              this.errorMensaje = mensajeError;
            } else {
              this.loading = false;
              this.change(4);
            }
          },
          error: (err) => {
            console.error('login.recuperar error', err);
            this.loading = false;
            this.errorMensaje = err?.error?.estado?.mensajeError || 'Error al recuperar contraseña';
          }
        });
      }
      break;
    }

    case 4: {
      if (!this.dpi || this.dpi.trim() === "") {
        this.errorMensaje = "Ingrese DNI.";
        this.loading = false;
      } else {
        this.errorMensaje = null;
        const jsonVal = {
          sDni: this.dpi,
          nIdEmpresa: 5,
          sTokenConfirmacion: this.tokenValida,
          sCaptchaToken: captchaToken
        };

        this.login.actualizaIndValido(jsonVal).subscribe({
          next: (res) => {
            this.response = res;
            const { estado } = this.response;
            const { numeroError } = estado;
            if (numeroError !== 0) {
              if (numeroError === 100) {
                this.loading = false;
                this.errorMensaje = 'Usuario ya se encuentra validado';
              } else if (numeroError === 200) {
                this.loading = false;
                this.errorMensaje = 'Los Token no coinciden';
              } else {
                this.loading = false;
                this.errorMensaje = this.response.msjError;
              }
            } else {
              window.history.pushState({}, document.title, window.location.origin + "/#/"); // limpia la url del token
              this.loading = false;
              this.change(7);
            }
          },
          error: (err) => {
            console.error('login.actualizaIndValido error', err);
            this.loading = false;
            this.errorMensaje = err?.error?.estado?.mensajeError || 'Error al validar token';
          }
        });
      }
      break;
    }

    default:
      this.loading = false;
      break;
  } // switch
} // send

  clearData() {
    this.dpi = '';
    this.password = '';
    this.nombre = '';
    this.apePaterno = '';
    this.apeMaterno = '';
    this.apeCasada = '';
    this.password2 = '';
    this.sexo = '';
    this.email = '';
    this.fecNacimiento = '';
    this.nacionalidad = '';
    this.direccion = '';
    this.tel = '';
    this.aceptaPoliticaTarjeta = false;
  }

  abrirPoliticaTarjeta(event?: any) {
    // Evita que el click en el link (dentro del <label>) también marque/desmarque el checkbox.
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.mostrarPoliticaTarjeta = true;
  }

  cerrarPoliticaTarjeta() {
    this.mostrarPoliticaTarjeta = false;
  }

  change(tipo) {
    this.clearData()
    this.errorMensaje = ""

    switch (tipo) {
      case 1:
        this.mensaje = false;
        this.default = true;
        this.recuperar = false;
        this.passReset = false;
        this.nuevo = false;
        this.validaCorreo = false;
        this.mensajeValidacion = false;
        this.title = "Bienvenido";
        this.subTitle = "Inicia sesión para continuar";
        this.button = "Iniciar sesión";
        this.tipo = 1;
        break;

      case 2:
        this.default = false;
        this.recuperar = false;
        this.nuevo = true;
        this.passReset = false;
        this.validaCorreo = false;
        this.title = "Para Comenzar";
        this.subTitle = "Crea una cuenta";
        this.button = "Crear cuenta";
        this.tipo = 2
        break;

      case 3:
        this.default = false;
        this.recuperar = true;
        this.nuevo = false;
        this.passReset = false;
        this.validaCorreo = false;
        this.title = "Recuperar cuenta";
        this.subTitle = "Intentemos recuperar el acceso a tu cuenta";
        this.button = "Enviarme código de recuperación";
        this.tipo = 3;
        break;

      case 4:
        this.mensaje = true;
        break;

      case 5:
        this.default = false;
        this.recuperar = false;
        this.nuevo = false;
        this.passReset = true;
        this.validaCorreo = false;
        this.title = "Cambiar Contraseña";
        this.subTitle = "";
        this.button = "Cambiar";
        break;

      case 6:
        this.default = false;
        this.recuperar = false;
        this.nuevo = false;
        this.passReset = false;
        this.validaCorreo = true;
        this.title = "Validar Correo";
        this.subTitle = "";
        this.button = "Validar";
        this.tipo = 4;
        break;

      case 7:
        this.mensajeValidacion = true;
        break;
    }
  }

  onlyNumber($event) {
    let key = $event.charCode;

    if (key <= 57 && key >= 48) {
      return true;

    } else {
      return false

    }
  }

  onlyLetter(event) {
    const pattern = /[^a-zA-ZñÑáéíóúÁÉÍÓÚäëïöüÄËÏÖÜ' ]/g
    event.target.value = event.target.value.replace(pattern, '');
  }

  onlyLetterWhitoutSpace(event) {
    const pattern = /[^a-zA-ZñÑáéíóúÁÉÍÓÚäëïöüÄËÏÖÜ']/g
    event.target.value = event.target.value.replace(pattern, '');
  }

  // Cédula panameña: letras, números y guion, sin formatear automáticamente.
  // Se deja tal cual lo escribe el usuario; el backend valida el formato final.
  onlyDniChars(event: any) {
    const pattern = /[^A-Za-z0-9-]/g
    event.target.value = event.target.value.replace(pattern, '');
    this.dpi = event.target.value;
  }

  comproboPass() {
    return this.password == this.password2
  }
  comproboField() {
    return (this.dpi == "" || this.nombre == "" || this.apePaterno == "" || this.password == "" || this.sexo == "" || this.email == "" || this.fecNacimiento == "" || this.nacionalidad == "" || this.direccion == "" || this.tel == "") ? false : true;
  }

  comproboEmail() {
    let mailValido = false;
    var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (this.email.match(EMAIL_REGEX)) {
      mailValido = true;
    }
    return mailValido;
  }

  comproboDate() :boolean {
    const [y, m, d] = this.fecNacimiento.split('-').map(Number);
    const fecha = new Date(y, m - 1, d); 
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return fecha >= today; 

  }

  async resetPassword() {
    if (this.password.length > 0 && this.password2.length > 0) {
      if (this.comproboPass()) {
        if (this.password.length < 6) {
          this.errorMensaje = "Contraseña debe tener mínimo 6 caracteres"
        } else {

          let captchaToken = '';
          try {
            captchaToken = await this.turnstile.execute('reset_password');
          } catch (e) {
            console.error('turnstile error', e);
          }

          this.json = {
            sTokenConfirmacion: this.token,
            sPassword: this.password,
            sCaptchaToken: captchaToken
          }

          this.login.resetPass(this.json).subscribe(res => {

            this.response = res;
            const { estado } = this.response;
            const { numeroError, mensajeError } = estado;
            if (numeroError != 0) {
              this.errorMensaje = mensajeError;
            } else {
              window.history.pushState({}, document.title, window.location.origin + "/#/"); //limpia la url del token
              this.change(4);
            }
          })
        }
      }
      else {
        this.errorMensaje = 'Las contraseñas deben ser iguales.'
      }
    }
    else {
      this.errorMensaje = 'Debe completar todos los campos.'
    }
  }


  comprobReEmail() {

    return this.email === this.REemail
  }
  addSession(idSession: string, nombre: string, hostName: string, usuarioWeb: string, bloqueos: any) {
    this.login.addSession(idSession, nombre, hostName, usuarioWeb, bloqueos);
  }
}
